export const reloadApp = () => {
  window.location.reload()
}
